<div class="box-theme">
  <div class="head">
    <div class="body">
      <h1>
        Te invitamos a planificar tu visita a nuestras oficinas de atención a <br/>
        clientes, para un acceso más rápido y seguro.
      </h1><br>
      <h2 class="subtitulo">
        <!--Dirección: El Regidor 54, Las Condes, Santiago.<br>-->
        Horario de atención: de lunes a viernes de 10:00 a 14:00 horas; excepto festivos.
      </h2>
    </div>
  </div>
  <div class="body">

    <!-- PASO NUMERO 2 -->
    <div class="paso-2 box-tomade-de-hora">
      <div class="header">
        <h3>
          Recuerda que si vives en comuna que está en cuarentena, debes solicitar un permiso temporal en <span (click)="openexternal()">www.comisariavirtual.cl</span>
        </h3>
        <h3>
          Ingresa tus datos:
        </h3>
      </div>
      <div class="body">
        <form [formGroup]="formData">
          <div class="form">
            <div class="head">
              <h2>
                Identificación del solicitante
              </h2>
              <p class="txt-orange">
                (**datos obligatorios)
              </p>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Ingresa tu nombre y apellido" formControlName="nombre" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.nombre.errors">
                        <p *ngIf="f.nombre.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.nombre.errors.pattern">
                          nombre inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Ingresa tu Rut" formControlName="rut" [maxLength]="12" [ngClass]="{ 'is-invalid': submitted && f.rut.errors }" (blur)="formatearRut($event)"/>
                    <div class="error">
                      <div *ngIf="submitted && f.rut.errors">
                        <p *ngIf="f.rut.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.rut.errors.maxlength || f.rut.errors.minlength || f.rut.errors?.rutValid">
                          rut inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="email" placeholder="**Ingresa e-mail" formControlName="email" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.email.errors">
                        <p *ngIf="f.email.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.email.errors.email || f.email.errors.maxlength">
                          email inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Dirección" formControlName="direccion" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.direccion.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.direccion.errors">
                        <p *ngIf="f.direccion.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.direccion.errors.pattern">
                          dirección inválida
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Teléfono" formControlName="telefono" [maxLength]="9" [ngClass]="{ 'is-invalid': submitted && f.telefono.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.telefono.errors"> 
                        <p *ngIf="f.telefono.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.telefono.errors.maxlength || f.telefono.errors.pattern">
                          teléfono inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <div class="cont-numero-cliente">
                      <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }"/>
                      <div class="div-numero-cliente">
                        <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                          <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                        </a>
                      </div>
                      <div class="error">
                        <div *ngIf="submitted && f.nCliente.errors">
                          <p *ngIf="f.nCliente.errors.required">
                            dato obligatorio
                          </p>
                          <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid">
                            número de cliente inválido
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <textarea placeholder="**Motivo de la visita" [maxLength]="300" formControlName="motivo" [ngClass]="{ 'is-invalid': submitted && f.motivo.errors }"></textarea>
                    <div class="div-motivo">
                    </div>
                    <div class="error">
                      <div *ngIf="submitted && f.motivo.errors">
                        <p *ngIf="f.motivo.errors.required">
                          dato obligatorio
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="form agendar-hora">
            <ul>
              <li class="box-calendario">
                <div class="box-campo-form">
                  <p-calendar formControlName="calendario" [locale]="es" [minDate]="minDateValue" [maxDate]="maxDateValue" [disabledDates]="invalidDates" [disabledDays]="[0,6]" placeholder="**Seleccionar fecha" (onSelect)="dateSelect()"></p-calendar>
                  <div class="error">
                    <div *ngIf="submitted && f.calendario.errors">
                      <p *ngIf="f.calendario.errors.required">
                        dato obligatorio
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              <li class="box-horario">
                <div class="box-campo-form">
                  <ng-select #horario
                                    [items]="dataHorarios"
                                    [selectOnTab]="true"
                                    bindValue="hour"
                                    bindLabel="hour"
                                    placeholder="**Selecciona horario"
                                    formControlName="horario"
                                    notFoundText="horario inválido">
                    </ng-select>
                  <div class="error">
                    <div *ngIf="submitted && f.horario.errors">
                      <p *ngIf="f.horario.errors.required">
                        dato obligatorio
                      </p>
                      <p *ngIf="f.horario.errors.min || f.horario.errors.max">
                        horario inválido
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              <li class="box-sucursal">
                <div class="box-campo-form">
                  <ng-select #sucursal
                                    [items]="dataSucursales"
                                    [selectOnTab]="true"
                                    bindValue="sucursales"
                                    bindLabel="sucursales"
                                    placeholder="**Selecciona sucursal"
                                    formControlName="sucursal"
                                    notFoundText="sucursal inválida"
                                    (change)="dateSelect()">
                    </ng-select>
                  <div class="error">
                    <div *ngIf="submitted && f.sucursal.errors">
                      <p *ngIf="f.sucursal.errors.required">
                        dato obligatorio
                      </p>
                      <p *ngIf="f.sucursal.errors.min || f.sucursal.errors.max">
                        sucursal inválida
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="form">
            <div class="footer">
              <div class="callToAcction">
                <!-- <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']"> -->
                <input type="button" value="ENVIAR" class="btn btn-continuar" (click)="onSubmit()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal-requerido">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <br>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<!-- <div class="modal-exito">
  <div class="punto-informacion">
    <h3>Tu hora ha sido reservada con exito, pronto recibirás un correo electrónico de confirmación.</h3>
    <br>
    <div class="btn-cerrar">
      <img src="../../assets/img/close.svg"  onclick="$('.basicLightbox').hide();" />
    </div>
    <br>
  </div>
</div> -->

<div class="modal-error">
  <div class="punto-informacion">
    <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
    <br>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<div class="modal-numero-cliente">
  <div class="punto-informacion">
    <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
    <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
    <br>
    <p class="texto-numero-cliente">
      Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
      <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
    </p>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>



<ngx-spinner></ngx-spinner>
